// extracted by mini-css-extract-plugin
export default {"facetMenu":"du-z","fixed":"eu-z","nonLayerdFacets":"fu-z","productCount":"gu-z","facetBack":"hu-z","arrow":"iu-z","facetClose":"ju-z"};